import { Link } from 'react-router-dom';

const SMSTerms = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',
      padding: '2rem'
    }}>
      <div style={{ 
        maxWidth: '800px', 
        margin: '0 auto', 
        background: 'white', 
        borderRadius: '16px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{ 
          background: 'linear-gradient(135deg, #2c5364 0%, #203a43 100%)',
          padding: '2rem',
          textAlign: 'center',
          color: 'white'
        }}>
          <img 
            src="/careguard-logo-full.jpg" 
            alt="CareGuard" 
            style={{ 
              height: '140px', 
              maxWidth: '100%',
              display: 'block',
              margin: '0 auto',
              marginBottom: '1rem',
              borderRadius: '8px',
              objectFit: 'contain'
            }}
          />
          <h1 style={{ margin: '0 0 0.5rem 0', fontSize: '1.8rem' }}>
            SMS Terms & Conditions
          </h1>
          <p style={{ margin: 0, opacity: 0.9 }}>
            CareGuard Caregiver Wellness Monitoring Service
          </p>
          <p style={{ margin: '0.25rem 0 0', opacity: 0.8, fontSize: '0.85rem' }}>
            An entity of Bryant Enterprises LLC · careguardapp.com
          </p>
        </div>

        {/* Content */}
        <div style={{ padding: '2rem' }}>
          
          {/* Opt-In Disclosure */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#2c5364', borderBottom: '2px solid #e8f4f8', paddingBottom: '0.5rem' }}>
              📱 SMS Messaging Opt-In Disclosure
            </h2>
            <div style={{ 
              background: '#e7f3ff', 
              padding: '1.5rem', 
              borderRadius: '8px',
              borderLeft: '4px solid #2c5364',
              marginTop: '1rem'
            }}>
              <p style={{ margin: '0 0 1rem 0', fontWeight: '600', color: '#0c5460' }}>
                By checking the "I agree to receive SMS notifications" box during registration, you expressly consent to receive the following types of text messages from CareGuard:
              </p>
              <ul style={{ margin: 0, paddingLeft: '1.5rem', color: '#0c5460' }}>
                <li>Check-in reminders when your wellness check-in is due</li>
                <li>Missed check-in alerts if you haven't responded</li>
                <li>Emergency escalation notifications</li>
                <li>Account security notifications</li>
                <li>Service updates related to your caregiver monitoring</li>
              </ul>
            </div>
          </section>

          {/* How to Opt-In */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#2c5364', borderBottom: '2px solid #e8f4f8', paddingBottom: '0.5rem' }}>
              ✅ How to Opt-In
            </h2>
            <p>To receive SMS notifications from CareGuard, you must:</p>
            <ol style={{ paddingLeft: '1.5rem' }}>
              <li><strong>Create an account</strong> on the CareGuard website</li>
              <li><strong>Provide your mobile phone number</strong> in the registration form</li>
              <li><strong>Check the consent checkbox</strong> that states: "I agree to receive SMS notifications from CareGuard for check-in reminders, alerts, and emergency notifications. Message and data rates may apply."</li>
              <li><strong>Complete registration</strong> by clicking the "Create Account" button</li>
            </ol>
            <p style={{ 
              background: '#fff3cd', 
              padding: '1rem', 
              borderRadius: '8px',
              color: '#856404',
              marginTop: '1rem'
            }}>
              <strong>⚠️ Important:</strong> You cannot create an account with SMS features enabled without explicitly checking the consent checkbox. This is a required step.
            </p>
          </section>

          {/* Message Frequency */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#2c5364', borderBottom: '2px solid #e8f4f8', paddingBottom: '0.5rem' }}>
              📊 Message Frequency
            </h2>
            <p>The frequency of SMS messages depends on your configured check-in schedule:</p>
            <ul style={{ paddingLeft: '1.5rem' }}>
              <li><strong>Check-in reminders:</strong> Sent when your check-in is due (based on your chosen interval: daily to weekly)</li>
              <li><strong>Missed check-in alerts:</strong> Sent if you miss a scheduled check-in (typically 1-3 messages during escalation)</li>
              <li><strong>Emergency notifications:</strong> Sent only during active emergency escalation</li>
              <li><strong>Estimated total:</strong> 2-10 messages per week depending on your settings and check-in compliance</li>
            </ul>
          </section>

          {/* How to Opt-Out */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#2c5364', borderBottom: '2px solid #e8f4f8', paddingBottom: '0.5rem' }}>
              🚫 How to Opt-Out (STOP)
            </h2>
            <div style={{ 
              background: '#f8d7da', 
              padding: '1.5rem', 
              borderRadius: '8px',
              borderLeft: '4px solid #dc3545'
            }}>
              <p style={{ margin: '0 0 1rem 0', fontWeight: '600', color: '#721c24' }}>
                You can opt out of SMS messages at any time by:
              </p>
              <ol style={{ margin: 0, paddingLeft: '1.5rem', color: '#721c24' }}>
                <li><strong>Replying STOP</strong> to any message you receive from CareGuard</li>
                <li><strong>Updating your preferences</strong> in your account Profile Settings</li>
                <li><strong>Contacting us</strong> at support@careguardapp.com</li>
              </ol>
            </div>
            <p style={{ marginTop: '1rem' }}>
              After opting out, you will receive one final confirmation message. You will no longer receive SMS notifications, but you can still use the web application to perform check-ins.
            </p>
            <p style={{ 
              background: '#fff3cd', 
              padding: '1rem', 
              borderRadius: '8px',
              color: '#856404'
            }}>
              <strong>⚠️ Safety Warning:</strong> If you opt out of SMS notifications, your emergency contacts will NOT be notified via SMS if you miss a check-in. Only email and voice call notifications will be used.
            </p>
          </section>

          {/* Help */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#2c5364', borderBottom: '2px solid #e8f4f8', paddingBottom: '0.5rem' }}>
              ❓ Help & Support
            </h2>
            <p>If you need assistance with SMS messaging:</p>
            <ul style={{ paddingLeft: '1.5rem' }}>
              <li><strong>Reply HELP</strong> to any message for support information</li>
              <li><strong>Email:</strong> support@careguardapp.com</li>
              <li><strong>Website:</strong> Visit your Profile Settings to manage notification preferences</li>
            </ul>
          </section>

          {/* Message & Data Rates */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#2c5364', borderBottom: '2px solid #e8f4f8', paddingBottom: '0.5rem' }}>
              💵 Message & Data Rates
            </h2>
            <p>
              <strong>Message and data rates may apply.</strong> CareGuard does not charge for SMS messages, but your mobile carrier may charge standard messaging rates. Please contact your carrier for details about your messaging plan.
            </p>
          </section>

          {/* Privacy */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#2c5364', borderBottom: '2px solid #e8f4f8', paddingBottom: '0.5rem' }}>
              🔒 Privacy & Data Protection
            </h2>
            <p>Your phone number and messaging data are protected:</p>
            <ul style={{ paddingLeft: '1.5rem' }}>
              <li>We <strong>never sell or share</strong> your phone number with third parties for marketing</li>
              <li>Your number is only used for CareGuard wellness monitoring notifications</li>
              <li>Messages are sent via secure, HIPAA-compliant messaging providers</li>
              <li>You can request deletion of your data at any time by contacting support</li>
            </ul>
          </section>

          {/* Supported Carriers */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#2c5364', borderBottom: '2px solid #e8f4f8', paddingBottom: '0.5rem' }}>
              📶 Supported Carriers
            </h2>
            <p>CareGuard SMS messaging is supported on all major US carriers including:</p>
            <p style={{ color: '#6b8899' }}>
              AT&T, Verizon, T-Mobile, Sprint, US Cellular, Cricket, MetroPCS, Boost Mobile, Virgin Mobile, and most regional carriers.
            </p>
          </section>

          {/* Service Provider */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#2c5364', borderBottom: '2px solid #e8f4f8', paddingBottom: '0.5rem' }}>
              🏢 Service Provider Information
            </h2>
            <div style={{ 
              background: '#f8f9fa', 
              padding: '1.5rem', 
              borderRadius: '8px',
              overflowWrap: 'anywhere'
            }}>
              <p style={{ margin: '0 0 0.5rem 0' }}><strong>Service Name:</strong> CareGuard</p>
              <p style={{ margin: '0 0 0.5rem 0' }}><strong>Service Type:</strong> Caregiver Wellness Monitoring & Emergency Alert System</p>
              <p style={{ margin: '0 0 0.5rem 0' }} data-testid="sms-business-name"><strong>Business Name:</strong> Bryant Enterprises LLC (CareGuard is an entity of Bryant Enterprises LLC)</p>
              <p style={{ margin: '0 0 0.5rem 0' }} data-testid="sms-business-address"><strong>Business Address:</strong> 850 Dogwood Road Suite B200 #2060, Lawrenceville, Georgia 30044, United States</p>
              <p style={{ margin: '0 0 0.5rem 0' }}><strong>Website:</strong> https://www.careguardapp.com</p>
              <p style={{ margin: '0 0 0.5rem 0' }}><strong>Support Email:</strong> support@careguardapp.com</p>
              <p style={{ margin: 0 }}><strong>SMS Number:</strong> +1 (844) 524-8078</p>
            </div>
          </section>

          {/* CTIA Keywords */}
          <section>
            <h2 style={{ color: '#2c5364', borderBottom: '2px solid #e8f4f8', paddingBottom: '0.5rem' }}>
              🔑 Supported Keywords
            </h2>
            <ul>
              <li><strong>STOP / STOPALL / UNSUBSCRIBE / CANCEL / END / QUIT</strong> — Unsubscribe from all CareGuard SMS alerts. You will receive one confirmation message.</li>
              <li><strong>START / UNSTOP / YES</strong> — Resubscribe after opting out.</li>
              <li><strong>HELP / INFO</strong> — Receive support contact info.</li>
            </ul>
          </section>

          {/* Terms Agreement */}
          <section style={{ 
            background: 'linear-gradient(135deg, #e7f3ff 0%, #d1ecf1 100%)',
            padding: '1.5rem',
            borderRadius: '8px',
            textAlign: 'center'
          }}>
            <p style={{ margin: '0 0 1rem 0', color: '#0c5460' }}>
              By registering for CareGuard and checking the SMS consent checkbox, you acknowledge that you have read, understood, and agree to these SMS Terms & Conditions.
            </p>
            <p style={{ margin: 0, fontSize: '0.9rem', color: '#6b8899' }}>
              Last updated: February 2026
            </p>
          </section>

          {/* Navigation */}
          <div style={{ 
            marginTop: '2rem', 
            textAlign: 'center',
            borderTop: '1px solid #e8f4f8',
            paddingTop: '1.5rem'
          }}>
            <Link 
              to="/auth" 
              style={{
                display: 'inline-block',
                padding: '0.75rem 2rem',
                background: 'linear-gradient(135deg, #2c5364 0%, #203a43 100%)',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '25px',
                fontWeight: '600'
              }}
            >
              Create an Account
            </Link>
            <p style={{ marginTop: '1rem', color: '#6b8899' }}>
              Already have an account? <Link to="/auth" style={{ color: '#2c5364' }}>Login here</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SMSTerms;
